import { useTreatments } from '@splitsoftware/splitio-react';

export function useFeatureFlag(
  flag: string,
  key?: string,
  attributes?: Record<string, any>
): boolean {
  const splitNames = [flag];
  const obj: SplitIO.TreatmentsWithConfig = useTreatments(
    splitNames,
    attributes,
    key
  );
  return obj[flag].treatment === 'on';
}

/**
 * Old method of checking feature flags using attributes, without any key - equivalent to
 * useFeatureFlag(flag, undefined, attributes).
 * @deprecated
 **/
export function useDeprecatedFeatureFlag(flag, attributes?): boolean {
  return useFeatureFlag(flag, undefined, attributes);
}

export default useFeatureFlag;
